import { AdminShell, PageLoader } from '../../../components';
import { useAdminEditProductsLogic } from './logic';
import ProductForm from './productForm/ProductForm';

export const EditProduct = () => {
	const { isLoading, formik } = useAdminEditProductsLogic();

	return (
		<AdminShell pageTitle="Edit Product">
			{isLoading ? <PageLoader /> : <ProductForm formik={formik} />}
		</AdminShell>
	);
};

export default EditProduct;
